import InvitationVue from '@/views/sic/invitation/invitation.vue';

const basePath = '/sic/invitation';
const role = 'sic'; // 角色身份

export const SIC_INVITATION_INDEX = 'sic-invitation-index';
export const SIC_INVITATION_PREVIEW = 'sic-invitation-preview';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: InvitationVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_INVITATION_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/invitation/index.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/preview`,
      name: SIC_INVITATION_PREVIEW,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/invitation/preview.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
